import * as ActionTypes from '../actions/camerasHistoryPlayerAction';

const initialState = {
  startDate: null,
  endDate: null,
  pollingStartDate: null,
  pollingEndDate: null,
  timeInterval: null,
};

const camerasHistoryPlayerReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.CHANGE_CHP_SEVERAL_VALUES: {
      return {
        ...state,
        ...action.payload,
      };
    }
    
    case ActionTypes.RESET_CHP_STORE: {
      return {
        ...state,
        ...initialState,
      };
    }
    
    default: {
      return state;
    }
  }
};

export default camerasHistoryPlayerReducer;
